import { LagTypeEnum } from 'redux-store/api/company';
import { IDatePopperMaxDate, IPredecessor } from '../types';
import { addDaysToDateHelper } from 'utils/helpers/date.helpers';
import { calculateStartDate } from '../../../sections/gantt/helpers';

export function getMinimumAllowedDate(predecessors: IPredecessor[]): string | null {
  if (!predecessors?.length) return null;

  const candidateDates = predecessors.map((p) => p.startDate);

  const startDate = candidateDates.reduce((latest, current) =>
    new Date(current) > new Date(latest) ? current : latest
  );

  return startDate;
}

export const getMinStartDate = (fields, itemsListOptions, lagType, workingDays) => {
  if (!fields?.length) {
    return null;
  }

  if (lagType === LagTypeEnum.MAINTAIN) {
    return getMinimumAllowedDate(fields);
  }

  const predecessorsInfo = [];

  fields?.map((item: any) => {
    const pItem = itemsListOptions?.find(
      (predecessor) => predecessor?.value === item?.predecessorId
    );

    predecessorsInfo.push({
      startDate: pItem?.startDate,
      endDate: pItem?.endDate,
      lagDays: item?.lagDays,
    });
  });

  // if (lagType === LagTypeEnum.MAINTAIN) {
  //   const maxStartDate = predecessorsInfo?.reduce((acc, current) => {
  //     return new Date(current.startDate) > new Date(acc.startDate) ? current : acc;
  //   });

  //   return addDaysToDateHelper(maxStartDate.startDate, 1);
  // }

  const maxEndDate: IDatePopperMaxDate = predecessorsInfo?.reduce((acc, current) => {
    return new Date(current.endDate) > new Date(acc.endDate) ? current : acc;
  });

  if (lagType === LagTypeEnum.MINIMUM && Number(maxEndDate.lagDays) === 0) {
    return addDaysToDateHelper(maxEndDate.startDate, 1);
  }

  const formatedEndDate = addDaysToDateHelper(maxEndDate.endDate, 2);

  const maxDate = calculateStartDate(formatedEndDate, maxEndDate.lagDays, workingDays);

  return maxDate;
};
